// bootstrap Components
import { Container, Row, Col } from "react-bootstrap";

// This component will be used as the user profile
const Profile = () => {
  return (
    <section className="profile">
      <Container>
        <Row>
          <Col>
            <h1 className="section-heading">User Profile</h1>
            <p className="text-center">
              Lorem ipsum dolor, sit amet consectetur adipisicing elit. Maiores,
              eius.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Profile;
